import { useDisclosure } from '@nextui-org/react';
import { useState } from 'react';
import { PopupWithTwoInput } from '../../../components/popups';
import { sanitizeHTML } from '../../../utils/functions/formatting_functions';
import UtilitiesRepository from '../../../data/repositories/utilities_repository';
import { toast } from 'react-toastify';

export const UpdateNameOrDescriptionModal = ({
  listing,
  typeOfText,
  children,
  onCancel,
  onUpdated,
  dataEditingRepository,
  useSolrKeys,
}: {
  listing: any;
  typeOfText: 'name' | 'description';
  children: React.ReactNode;
  // allow to accept some or none of the values
  onUpdated: (values: { new_value1: string; new_value2: string }) => void;
  onCancel?: () => void;
  dataEditingRepository: any;
  useSolrKeys?: boolean;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [updateTextModal, setUpdateTextModal] = useState('');
  const [clickNumber, setClickNumber] = useState(0);
  const { key1, key2, key3, key4 } =
    typeOfText === 'name'
      ? {
          key1: 'name_en',
          key2: 'name_ar',
          key3: 'description_en',
          key4: 'description_ar',
        }
      : {
          key1: 'description_en',
          key2: 'description_ar',
          key3: 'name_en',
          key4: 'name_ar',
        };
  return (
    <>
      <div
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setUpdateTextModal(typeOfText === 'name' ? 'Name' : 'Description');
          onOpen();
        }}
      >
        {children}
      </div>
      <PopupWithTwoInput
        open={isOpen && dataEditingRepository}
        onButtonOneClick={() => {
          onCancel && onCancel();
          setUpdateTextModal('');
          onClose();
        }}
        headerTitle={`Update ${updateTextModal}`}
        inputOneLabel={updateTextModal + ' (English)'}
        inputOneInitialValue={
          typeOfText === 'name'
            ? listing[key1 as keyof typeof listing]?.toString()
            : listing[
                (useSolrKeys
                  ? 'listing_description_en'
                  : 'rich_text_description_en') as keyof typeof listing
              ]?.toString()
        }
        inputOneAsHtmlEditor={typeOfText === 'description'}
        inputTwoAsHtmlEditor={typeOfText === 'description'}
        inputOnePlaceholder="Enter new English value"
        inputOneValidator={(e: string) => !e}
        inputTwoLabel={updateTextModal + ' (Arabic)'}
        inputTwoInitialValue={
          typeOfText === 'name'
            ? listing[key2 as keyof typeof listing]?.toString()
            : listing[
                (useSolrKeys
                  ? 'listing_description_ar'
                  : 'rich_text_description_ar') as keyof typeof listing
              ]?.toString()
        }
        inputTwoPlaceholder="Enter new Arabic value"
        inputTwoValidator={(e: string) => !e}
        inputTwoDir="rtl"
        inputOneAsTextAreaInsteadOfSingleInput
        inputTwoAsTextAreaInsteadOfSingleInput
        buttonTwoText="Update"
        onButtonTwoClick={async (new_value1: string, new_value2: string) => {
          if (new_value1 === '') {
            return;
          }
          await dataEditingRepository
            .updateListingNameOrDescription({
              listing_id: useSolrKeys ? listing.listing_id : listing.id,
              [key1]:
                typeOfText === 'name'
                  ? new_value1
                  : sanitizeHTML(new_value1).__html,
              [key2]:
                typeOfText === 'name'
                  ? new_value2
                  : sanitizeHTML(new_value2).__html,
              [key3]:
                listing[
                  typeOfText === 'name'
                    ? ((useSolrKeys
                        ? 'listing_description_en'
                        : 'rich_text_description_en') as keyof typeof listing)
                    : ('name_en' as keyof typeof listing)
                ],
              [key4]:
                listing[
                  typeOfText === 'name'
                    ? ((useSolrKeys
                        ? 'listing_description_ar'
                        : 'rich_text_description_ar') as keyof typeof listing)
                    : ('name_ar' as keyof typeof listing)
                ],
            })
            .then((res: any) => {
              if (!res) {
                return;
              }
              setUpdateTextModal('');
              onUpdated({
                new_value1,
                new_value2,
              });
              onClose();
            });
        }}
        buttonExtraColor="primary"
        buttonExtraText={clickNumber % 2 === 0 ? 'Rewrite' : 'Restore'}
        onButtonExtraClick={
          typeOfText !== 'name'
            ? undefined
            : async (
                new_value1: string,
                setNewValue1: (value: string) => void,
                new_value2: string,
                setNewValue2: (value: string) => void,
              ) => {
                if (clickNumber % 2 === 1) {
                  setNewValue1(listing[key1 as keyof typeof listing]);
                  setNewValue2(listing[key2 as keyof typeof listing]);
                  toast.info('Restored original values try again to rewrite');
                } else {
                  await UtilitiesRepository.rewriteNamesWithOpenAI(
                    new_value1,
                    new_value2,
                    `About the product ENGLISH:${listing[key3 as keyof typeof listing]}. About the product ARABIC:${
                      listing[key4 as keyof typeof listing]
                    }`,
                  ).then((res) => {
                    if (!res) {
                      return;
                    }
                    setNewValue1(res.suggested_name_en);
                    setNewValue2(res.suggested_name_ar);
                  });
                }
                setClickNumber(clickNumber + 1);
              }
        }
        clearOnSubmit={false}
      />
    </>
  );
};
